module.exports = __webpack_public_path__ + "static/logogreen-ddd3bfe952c490a82ffacf49d0e4f9ad.svg";